import { render } from "./AvisOffrePage.vue?vue&type=template&id=50f6eab1&ts=true"
import script from "./AvisOffrePage.vue?vue&type=script&lang=ts"
export * from "./AvisOffrePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__